import { SeatLegendItem } from '../charter.types';

type SeatStatusLegend = {
  key: 'available' | 'selected' | 'unavailable';
  label: string;
  color: string;
};

const SEAT_STATUS_LEGEND: Array<SeatStatusLegend> = [
  {
    key: 'available',
    label: 'Available',
    color: '#80cbc4',
  },
  {
    key: 'selected',
    label: 'Selected',
    color: '#1e88e5',
  },
  {
    key: 'unavailable',
    label: 'Unavailable',
    color: '#cfd8dc',
  },
];

export const seatLegend: Array<SeatLegendItem> = [...SEAT_STATUS_LEGEND.map(({ label, color }) => ({ label, color }))];
